import '@updater-components/tooltip';
import template from './summary.html';
import { groupBy, partial, flow, transform, filter } from 'lodash-es';
import { selectors, actions } from '../../../../state';
import { ITEM_KINDS, STATES, IS_TOUCH_DEVICE } from '../../../../constants';
import './summary.global.css';

const GROUP_ITEM_KINDS = ['forward_mail', 'update_account'];

class MovesSummaryController {
  constructor(UyaTextHelper, updStore) {
    'ngInject';
    Object.assign(this, {
      updStore,
      uyaHelper: UyaTextHelper,
    });
  }

  $onInit() {
    const { dispatch, connect } = this.updStore;

    this.disconnect = connect(mapStateToThis)(this);
    this.forwardMailUiSref = STATES.STEP_FORWARD_MAIL_LIST;

    // Have to get the move since the moves returned in
    // the session do not have move items.
    dispatch(actions.move.singleton(this.moveId).read());
  }

  $onDestroy() {
    this.disconnect();
  }

  popoverText(account) {
    return this.uyaHelper.plainText(account, this.moveDate);
  }

  onSelect(selected) {
    this.dispatch(actions.router.stateGo('.', { moveId: selected.id }));
  }

  get showTooltips() {
    return !IS_TOUCH_DEVICE;
  }
}

function getItemKindsByName(items) {
  return flow(
    partial(filter, partial.placeholder, isItemToGroup),
    partial(groupBy, partial.placeholder, item => item.kind),
    partial(transform, partial.placeholder, transformToGroupByName)
  )(items);
}

function groupByName(items) {
  return groupBy(items, item => item.fullName.toUpperCase());
}

function isInGroupedItemKinds(item) {
  return GROUP_ITEM_KINDS.includes(item.kind);
}

function isItemToGroup(item) {
  return isInGroupedItemKinds(item) && !!item.fullName;
}

function transformToGroupByName(result, items, key) {
  // Have to sort to guarantee order of object keys (i.e. names)
  return (result[key] = sortNamedGroupByKey(groupByName(items)));
}

// Sorts an object by key name so we keep the same order across
// all objects.
function sortNamedGroupByKey(groups) {
  return Object.keys(groups)
    .sort()
    .reduce((result, key) => {
      result[key] = groups[key];
      return result;
    }, {});
}

function mapStateToThis(state) {
  const move = selectors.move.byId(
    selectors.router.currentParamsProp('moveId', state)
  );
  const items = move.items(state).map(mapItem(state));
  const itemsByKind = getItemKindsByName(items, state);

  return {
    move: move.identity(state),
    moveDate: move.date(state),
    items: itemsByKind,
    hasMoveItems: !!(
      itemsByKind[ITEM_KINDS.FORWARD_MAIL] ||
      itemsByKind[ITEM_KINDS.UPDATE_ACCOUNT]
    ),
    moves: selectors.current
      .user(state)
      .moves(state)
      .map(move => move.identity(state)),
    moveId: move.id(state),
  };
}

function mapItem(state) {
  return item => ({
    kind: item.kind(state),
    fullName: item.name(state).fullName(state),
    businessName: item.businessName(state),
    startDate: item.startDate(state),
    status: item.status(state),
    statusUpdatedAt: item.statusUpdatedAt(state),
    formType: item.formType(state),
    organization: {
      name: item.organization(state).name(state),
    },
  });
}

export const MovesSummaryComponent = {
  template,
  controller: MovesSummaryController,
};
